export interface FormFieldValueListItemModel {
  value: string | number | boolean;
  label?: string;
}
